const doc = [({"en":({"js":({"school_classes":({"select":({"choose_school_class":"Choose school class"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;